// extracted by mini-css-extract-plugin
export default {"addButton":"Confirmation__addButton___NrktT","confirmationTitle":"Confirmation__confirmationTitle___kIDUh"};